(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nh-bundle-community-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
 const button=event.target.closest('.nh-bundle-community__play');
 if(!button)return;
 const video=button.previousElementSibling;
 document.querySelectorAll('.nh-bundle-community video').forEach(function(other){if(other!==video)other.pause();});
 if(!video.src)video.src=video.dataset.communitySrc;
 video.play().then(function(){button.hidden=true;}).catch(function(){button.hidden=false;});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nh-pilot-bundle-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => root.querySelectorAll('[data-nh-bundle-host]').forEach(host => {
      if (host.dataset.initialized) return;
      host.dataset.initialized = 'true';
      const dialog = host.querySelector('dialog');
      const submit = host.querySelector('[data-nh-bundle-submit]');
      const message = host.querySelector('[data-nh-bundle-message]');
      const cartLink = host.querySelector('[data-nh-bundle-cart]');
      const items = [...host.querySelectorAll('[data-nh-bundle-product]')].map(row => ({row, id:row.dataset.id, price:Number(row.dataset.price), available:row.dataset.available === 'true', quantity:0}));
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:host.dataset.currency || 'EUR'}).format(cents / 100);
      let busy = false;
      let added = false;
      let opener;
      const calculate = () => {
        const count = items.reduce((sum,item) => sum + item.quantity, 0);
        const percent = count >= 3 ? Number(host.dataset.discountThree) : count === 2 ? Number(host.dataset.discountTwo) : 0;
        const subtotal = items.reduce((sum,item) => sum + item.quantity * item.price, 0);
        const total = items.reduce((sum,item) => sum + item.quantity * (item.price - Math.floor(item.price * percent / 100)), 0);
        return {count,percent,subtotal,total};
      };
      const update = () => {
        const {count,percent,subtotal,total} = calculate();
        items.forEach(item => {
          item.row.querySelector('[data-nh-bundle-price]').textContent = money(item.price);
          item.row.querySelector('[data-nh-bundle-quantity]').textContent = item.quantity;
          item.row.querySelector('[data-nh-bundle-less]').disabled = busy || item.quantity === 0;
          item.row.querySelector('[data-nh-bundle-more]').disabled = busy || !item.available || count >= 3;
          item.row.classList.toggle('is-selected',item.quantity > 0);
        });
        host.querySelector('[data-nh-bundle-count]').textContent = host.dataset.countText.replace('__COUNT__',count);
        host.querySelector('[data-nh-bundle-discount]').textContent = percent ? host.dataset.discountText.replace('__PERCENT__',percent) : '';
        host.querySelector('[data-nh-bundle-saving]').textContent = percent ? host.dataset.savingText.replace('__AMOUNT__',money(subtotal-total)) : '';
        host.querySelector('[data-nh-bundle-total]').textContent = money(total);
        const previous = host.querySelector('[data-nh-bundle-subtotal]');
        previous.textContent = money(subtotal);
        previous.hidden = !percent;
        host.querySelectorAll('[data-nh-bundle-tier]').forEach(tier => tier.classList.toggle('is-active', Number(tier.dataset.nhBundleTier) === count));
        submit.disabled = busy || added || count < 2 || count > 3;
        submit.textContent = busy ? host.dataset.loadingText : count < 2 ? host.dataset.minimumText : host.dataset.submitText;
      };
      const reset = () => {
        added = false;
        message.hidden = true;
        cartLink.hidden = true;
        submit.hidden = false;
        items.forEach(item => {item.quantity = item.id === host.dataset.currentVariant && item.available ? 1 : 0;});
        update();
      };
      reset();
      document.querySelectorAll('.nh-pilot-combine a, [data-nh-bottom-bundle]').forEach(link => {
        link.setAttribute('aria-haspopup','dialog');
        link.setAttribute('aria-controls',dialog.id);
        link.addEventListener('click', event => {
          event.preventDefault();
          opener = link;
          if (added) reset();
          host.querySelectorAll('.nh-bundle__product img').forEach(image => {image.loading = 'eager';});
          dialog.showModal();
        });
      });
      host.querySelector('[data-nh-bundle-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click',event => {if (event.target === dialog) dialog.close();});
      items.forEach(item => {
        item.row.querySelector('[data-nh-bundle-more]').addEventListener('click', () => {
          if (busy || !item.available || calculate().count >= 3) return;
          item.quantity += 1; update();
        });
        item.row.querySelector('[data-nh-bundle-less]').addEventListener('click', () => {
          if (busy) return;
          item.quantity = Math.max(0,item.quantity-1); update();
        });
      });
      submit.addEventListener('click', async () => {
        const {count,percent} = calculate();
        if (busy || added || count < 2 || count > 3) return;
        busy = true; message.hidden = true; update();
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender().map(section => section.id) || ['cart-icon-bubble'];
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{
            method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:items.filter(item => item.quantity > 0).map(item => ({id:Number(item.id),quantity:item.quantity,properties:{'_Bundle-Typ':'Freie Produktauswahl','_Bundle-Staffel':`${count} Produkte / ${percent} %`}})),sections,sections_url:window.location.pathname})
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : host.dataset.errorText);
          added = true;
          if (drawer && sections.every(id => data.sections?.[id])) {
            dialog.close();
            drawer.classList.remove('is-empty');
            drawer.setActiveElement(opener);
            drawer.renderContents(data);
          } else {
            message.textContent = host.dataset.addedText;
            message.hidden = false; submit.hidden = true; cartLink.hidden = false;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'nh-pilot-bundle',cartData:data});
        } catch (error) {
          message.textContent = added ? host.dataset.addedText : error.message || host.dataset.errorText;
          message.hidden = false;
          if (added) {submit.hidden = true; cartLink.hidden = false; if (!dialog.open) dialog.showModal();}
        } finally {busy = false; update();}
      });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(),{once:true});
    else initialize();
    document.addEventListener('shopify:section:load',event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nh-pilot-pack-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-nh-pilot-packs]').forEach((selector) => {
        if (selector.dataset.initialized === 'true') return;
        const form = document.getElementById(selector.dataset.productFormId);
        const quantity = selector.querySelector('[data-nh-pilot-quantity]');
        const choices = Array.from(selector.querySelectorAll('[data-nh-pilot-choice]'));
        const submitLabel = form?.querySelector('.product-form__submit > span:not(.loading__spinner)');
        if (!form || !quantity || !choices.length) return;
        selector.dataset.initialized = 'true';
        const sync = (choice, broadcast = true) => {
          choice.checked = true;
          quantity.value = choice.value;
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
          const fields = {price:'price',compare:'compare',daily:'daily',unit:'unit',label:'selectedLabel',shipping:'shipping'};
          Object.entries(fields).forEach(([target,source]) => {
            const element = selector.querySelector(`[data-nh-selected-${target}]`);
            if (element) element.textContent = choice.dataset[source];
          });
          const compare = selector.querySelector('[data-nh-selected-compare]');
          if (compare) compare.hidden = choice.dataset.showCompare !== 'true';
          if (submitLabel && !form.querySelector('.product-form__submit')?.disabled) submitLabel.textContent = choice.dataset.cta;
          if (broadcast) document.dispatchEvent(new CustomEvent('nh:pack-change', {detail:{productId:selector.dataset.productId, value:choice.value, source:selector}}));
        };
        choices.forEach(choice => choice.addEventListener('change',() => sync(choice)));
        const peer = [...document.querySelectorAll('[data-nh-pilot-packs]')].find(el => el !== selector && el.dataset.productId === selector.dataset.productId && el.dataset.initialized === 'true');
        const current = peer?.querySelector('[data-nh-pilot-choice]:checked')?.value;
        const onSync = event => {
          if (event.detail.source === selector || event.detail.productId !== selector.dataset.productId) return;
          const choice = choices.find(item => item.value === event.detail.value);
          if (choice) sync(choice, false);
        };
        document.addEventListener('nh:pack-change', onSync);
        const onUnload = event => { if (event.target.contains(selector)) { document.removeEventListener('nh:pack-change',onSync); document.removeEventListener('shopify:section:unload',onUnload); } };
        document.addEventListener('shopify:section:unload',onUnload);
        sync(choices.find(choice => choice.value === current) || choices.find(choice => choice.checked) || choices[0], false);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(),{once:true});
    else initialize();
    document.addEventListener('shopify:section:load',event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nh-products-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nh-catalog-switcher')) {
    customElements.define('nh-catalog-switcher', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        if (this.dataset.mode === 'mobile') {
          this.toggles = Array.from(this.querySelectorAll('[data-mobile-toggle]'));
          const update = (button, open) => {
            button.setAttribute('aria-expanded', String(open));
            this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))).hidden = !open;
          };
          this.toggles.forEach((button, index) => {
            update(button, index === 0);
            button.addEventListener('click', () => {
              const open = button.getAttribute('aria-expanded') !== 'true';
              this.toggles.forEach(other => update(other, other === button && open));
            });
          });
          return;
        }
        this.tabs = Array.from(this.querySelectorAll('[data-group]'));
        this.panels = Array.from(this.querySelectorAll('[data-group-panel]'));
        const select = (tab, focus = false) => {
          this.tabs.forEach(button => {
            const active = button === tab;
            button.setAttribute('aria-expanded', String(active));
            button.classList.toggle('is-active', active);
          });
          this.panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
          if (focus) tab.focus();
        };
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab));
          tab.addEventListener('focus', () => select(tab));
          tab.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches &&
                !this.panels.some(panel => panel.contains(document.activeElement))) select(tab);
          });
          tab.addEventListener('keydown', event => {
            let target = index;
            if (event.key === 'ArrowDown') target = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowUp') target = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') target = 0;
            else if (event.key === 'End') target = this.tabs.length - 1;
            else if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.panels.find(panel => !panel.hidden)?.querySelector('a')?.focus();
              return;
            } else return;
            event.preventDefault();
            select(this.tabs[target], true);
          });
        });
        select(this.tabs[0]);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nh-site-breadcrumbs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nh-breadcrumb-disclosure')) {
  customElements.define('nh-breadcrumb-disclosure', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.setViewport = () => { this.details.open = !this.mobileQuery.matches; };
      this.mobileQuery.addEventListener('change', this.setViewport);
      this.setViewport();
      this.syncSurface = () => {
        const region = this.closest('[data-nh-breadcrumb]');
        if (!region || region.closest('.nh-main-product-pilot')) return;
        const visible = element => element && !element.matches('script, style, link, template, [hidden]') &&
          getComputedStyle(element).display !== 'none' && element.getClientRects().length > 0;
        let cursor = region;
        let target = null;
        const main = region.closest('main');
        // Breadcrumbs can be inside a hero or immediately before a template.
        while (cursor && cursor !== main && !target) {
          let sibling = cursor.nextElementSibling;
          while (sibling && !visible(sibling)) sibling = sibling.nextElementSibling;
          if (sibling) target = sibling;
          else cursor = cursor.parentElement;
        }
        if (!target) target = region.parentElement;
        const painted = element => {
          const style = getComputedStyle(element);
          const color = style.backgroundColor;
          return style.backgroundImage !== 'none' ||
            (color !== 'transparent' && !/rgba\([^)]*,\s*0(?:\.0+)?\s*\)$/.test(color));
        };
        let surface = target;
        // Section wrappers often have no background; use their first content surface.
        for (let depth = 0; surface && depth < 6 && !painted(surface); depth++) {
          const first = Array.from(surface.children).find(visible);
          if (!first) break;
          surface = first;
        }
        while (surface && surface !== main && !painted(surface)) surface = surface.parentElement;
        if (!surface || surface === region || region.contains(surface)) return;
        const style = getComputedStyle(surface);
        region.style.setProperty('--nh-breadcrumb-background', style.backgroundColor);
        region.style.setProperty('--nh-breadcrumb-foreground', style.color);
        region.style.backgroundImage = style.backgroundImage;
        region.style.backgroundRepeat = style.backgroundRepeat;
        region.style.backgroundPosition = style.backgroundPosition;
        region.style.backgroundSize = style.backgroundImage === 'none' ? 'auto' :
          surface.getBoundingClientRect().width + 'px ' + surface.getBoundingClientRect().height + 'px';
      };
      this.queueSurface = () => {
        cancelAnimationFrame(this.surfaceFrame);
        this.surfaceFrame = requestAnimationFrame(this.syncSurface);
      };
      window.addEventListener('load', this.queueSurface);
      window.addEventListener('resize', this.queueSurface);
      document.addEventListener('shopify:section:load', this.queueSurface);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.queueSurface, { once: true });
      }
      this.queueSurface();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.surfaceFrame);
      window.removeEventListener('load', this.queueSurface);
      window.removeEventListener('resize', this.queueSurface);
      document.removeEventListener('shopify:section:load', this.queueSurface);
      document.removeEventListener('DOMContentLoaded', this.queueSurface);
      if (this.mobileQuery && this.setViewport) {
        this.mobileQuery.removeEventListener('change', this.setViewport);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
